<div class="reddi-round-stepper">
  <div class="reddi-step">
    <div class="step-number">
      <div class="icons-above">
        <mat-icon class="reddi-assessment-stepper-icon1"
          >arrow_forward_ios</mat-icon
        >
        <mat-icon class="reddi-assessment-stepper-icon2"
          >arrow_forward_ios</mat-icon
        >
      </div>
    </div>
    <div class="reddi-step-content">
      <div class="step-setup">{{ steps?.setupTitle }}</div>
      <div class="reddi-assesment-response-icons">
        <mat-icon class="reddi-assessment-stepper-response-icon"
          >arrow_forward_ios</mat-icon
        >
        <mat-icon class="reddi-assessment-stepper-response-icon"
          >arrow_forward_ios</mat-icon
        >
        <div class="step-response" style="align-content: center">
          {{ steps?.responseTitle }}
        </div>
      </div>
    </div>
  </div>
</div>
